import useMediaQuery from '@mui/material/useMediaQuery';
import {theme} from '../theme/theme'

function useIsMobile(breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl') {
    return useMediaQuery(theme.breakpoints.down(breakpoint ?? 'sm'));
}

export default useIsMobile;
